export default __webpack_public_path__ + "static/media/picker-wheel-mask.69bf6fb3.svg";